module.exports = __webpack_public_path__ + "./fonts/filter.d463e3608fcfc44e597b9388b6346c31.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/filter.svg
// module id = ./assets/images/filter.svg
// module chunks = 0